/* src/app/views/display/components/modals/add-menu-or-collection-modal/select-menu-or-collection-results/menu-results/menu-results.component.scss */
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f6px {
  font-size: 0.375rem;
}
.f8px {
  font-size: 0.5rem;
}
.f10px {
  font-size: 0.625rem;
}
.f11px {
  font-size: 0.6875rem;
}
.f12px {
  font-size: 0.75rem;
}
.f13px {
  font-size: 0.8125rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.menu-results-container {
  padding-inline: 0.2rem;
}
.add-menu-list-item-container {
  background: #ffffff;
  padding: 0.5rem 0;
}
.add-menu-list-item-container:first-child {
  padding-top: 0.25rem;
}
.add-menu-list-item-container:last-child {
  padding-bottom: 1rem;
}
.add-menu-list-item {
  padding: 0.75rem 1rem;
  color: #222222;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  box-sizing: border-box;
  cursor: pointer;
  background: #ffffff;
  z-index: 99;
  box-shadow: 0 0 2px 2px rgba(218, 220, 222, 0.7);
  border-radius: 0.625rem;
}
.add-menu-list-item.disabled {
  cursor: not-allowed;
  background-color: #e8e8e8;
}
.draft-template-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.menu-added {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
/*# sourceMappingURL=menu-results.component.css.map */
